module.exports = __webpack_public_path__ + "static/img/chanliang.08a8382a.png";